import {
  HTTP_CREATESPECIAL_FETCHING,
  HTTP_CREATESPECIAL_SUCCESS,
  HTTP_CREATESPECIAL_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

//insert Special

export const setStateinsertSpecialToFetching = () => ({
  type: HTTP_CREATESPECIAL_FETCHING,
});

export const setStateinsertSpecialToSuccess = (payload) => ({
  type: HTTP_CREATESPECIAL_SUCCESS,
  payload,
});

export const setStateinsertSpecialToFailed = (payload) => ({
  type: HTTP_CREATESPECIAL_FAILED,
});

export const insertSpecialById = (item) => {
  return async (dispatch) => {
    dispatch(setStateinsertSpecialToFetching());
    try {
      await httpClient.post(`${server.CREATESPECIAL_URL}`, item);
      dispatch(setStateinsertSpecialToSuccess("success"));
    } catch (error) {
      dispatch(setStateinsertSpecialToFailed());
    }
  };
};
